// src/components/SpecializationButtons.jsx
import React, { useRef, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { getSpecializationConfigs } from '../config/fundConfigurations';

const SpecializationButtons = ({ category, selectedSpecialization, onSpecializationClick }) => {
  const scrollContainerRef = useRef(null);
  
  // קבלת כל ההתמחויות לקטגוריה הנוכחית
  const specializations = getSpecializationConfigs(category);

  // פונקציות גלילה אופקית
  const scrollLeft = () => {
    scrollContainerRef.current?.scrollBy({ left: -200, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollContainerRef.current?.scrollBy({ left: 200, behavior: 'smooth' });
  };

  // גלילה אוטומטית לכפתור הנבחר
  useEffect(() => {
    if (selectedSpecialization && scrollContainerRef.current) {
      const escapedKey = CSS.escape(selectedSpecialization);
      const selectedButton = scrollContainerRef.current.querySelector(`[data-specialization="${escapedKey}"]`);
      if (selectedButton) {
        selectedButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }, [selectedSpecialization]);

  if (!specializations || specializations.length === 0) {
    return null;
  }

  return (
    <div className="bg-white md:bg-transparent border-b border-slate-700 md:border-transparent shadow-lg md:shadow-none">
      <div 
        id="specialization-buttons-bar"
        className="max-w-7xl mx-auto py-3 relative"
      >
        {/* קונטיינר עם padding קבוע */}
        <div className="relative px-2 md:px-0">

          {/* שורת הכפתורים */}
          <div 
            ref={scrollContainerRef}
            className="flex gap-2 md:gap-4 overflow-x-auto md:overflow-visible md:flex-wrap md:justify-center py-2 md:py-2 custom-scrollbar"
            style={{ 
              scrollbarWidth: 'thin',
              scrollbarColor: '#9CA3AF #F3F4F6',
              msOverflowStyle: 'auto',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <style>
              {`
                .custom-scrollbar::-webkit-scrollbar {
                  height: 6px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                  background: #F3F4F6;
                  border-radius: 10px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                  background: #9CA3AF;
                  border-radius: 10px;
                }
              `}
            </style>
            {specializations.map((spec, index) => {
              const isSelected = selectedSpecialization === spec.key;
              
              // גרדיאנטים שונים בסגנון ה-Header
              const gradients = [
          
                'from-green-600 to-blue-500',
          
              ];
              
              const gradient = gradients[index % gradients.length];
              
              return (
                <button
                  key={spec.key}
                  data-specialization={spec.key}
                  onClick={() => onSpecializationClick(spec.key)}
                  className={`
                    relative group flex-shrink-0 
                    px-2 py-1 md:px-6 md:py-3.5 
                    rounded-lg md:rounded-xl font-bold text-[10px] md:text-sm
                    transition-all duration-500 transform hover:scale-105
                    ${isSelected 
                      ? `bg-gradient-to-br ${gradient} text-white shadow-2xl` 
                      : 'bg-white/10 hover:bg-white/20 backdrop-blur-xl border-2 border-slate-800/60 hover:border-slate-700/80 text-slate-900 hover:text-slate-800 shadow-md'
                    }
                  `}
                >
                  {/* זוהר חיצוני */}
                  <div className={`absolute -inset-1 rounded-xl blur-lg transition-all duration-500 ${
                    isSelected 
                      ? `bg-gradient-to-r ${gradient} opacity-50` 
                      : 'bg-white/10 opacity-0 group-hover:opacity-30'
                  }`}></div>
                  
                  {/* זוהר פנימי לכפתור נבחר */}
                  {isSelected && (
                    <div className="absolute inset-0 bg-gradient-to-r from-white/10 via-transparent to-white/10 rounded-xl animate-pulse"></div>
                  )}
                  
                  {/* טקסט */}
                  <span className="relative z-10 whitespace-nowrap">
                    {spec.title.split(' - ')[1] || spec.title}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecializationButtons;